var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneybag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6282 7.6615H22.6801L22.6276 5.8025H20.0477L22.4724 0.791286L19.7292 0.561741L17.3198 2.40861L18.1232 0.320071L15.3114 0L14.3892 2.60987L12.8737 0.589221L8.70483 0.444543L11.4633 5.80331L8.97316 5.72329V7.66069H11.3728C6.25506 10.6561 2.56787 18.4857 2.56787 22.7153C2.56787 28.0175 8.35809 31 15.4997 31C22.6413 31 28.4315 28.0175 28.4315 22.7153C28.4323 18.4857 24.7459 10.6569 19.6282 7.6615ZM16.5811 25.2589V27.0945H14.8167V25.385C13.6108 25.3325 12.4405 25.0059 11.7567 24.6115L12.2966 22.5068C13.0523 22.9214 14.1152 23.2981 15.2847 23.2981C16.3104 23.2981 17.0127 22.902 17.0127 22.1835C17.0127 21.4973 16.4372 21.0649 15.1053 20.6163C13.1784 19.9689 11.865 19.0677 11.865 17.3234C11.865 15.7392 12.9812 14.4961 14.9073 14.1195V12.4092H16.6716V13.9934C17.8767 14.0484 18.6882 14.2981 19.2814 14.5867L18.7593 16.6211C18.2913 16.4238 17.4629 16.0084 16.1673 16.0084C14.997 16.0084 14.6187 16.5119 14.6187 17.0155C14.6187 17.6104 15.2491 17.9878 16.7791 18.5641C18.9202 19.3223 19.785 20.31 19.785 21.9313C19.7858 23.5309 18.651 24.8993 16.5811 25.2589Z",
    fill: "#16DBCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneybag);
export default __webpack_public_path__ + "static/media/moneybag.008ac40ef8af09498468fce74019e351.svg";
export { ForwardRef as ReactComponent };